import React, { useEffect, useState } from 'react';
import useContext from '../../../../../hooks/useContext';
import useFilters from '../../Providers/useFilters';
import LinkButton from '../../../../../styled/LinkButton';

import { StoreContext } from '../../../../../providers/store';
import useInitialRender from '../../../../../hooks/useInitialRender';
import Distance from '../../../../../styled/Distance';
import Text from '../../../../../styled/Text';
import Skeleton from '../../../../../components-legacy/Skeleton';
import { isEmpty } from '../../../../../utils/object';
import useToggle from '../../../../../hooks/useToggle';
import LeadtimeFilterOptions from './LeadtimeFilterOptions';
import Box from '../../../../../styled/Box';
import Toggle from '../../../../../styled/Toggle';

import {
  DeliveryTime,
  LeadTimeSection,
  Pitch,
  Selections,
  Store,
  ToggleContainer,
  Wrapper,
  TextContainer,
  Description,
  Title,
} from './styled';
import { ChevronDownIcon, ChevronUpIcon, TruckIcon } from '../../../../../styled/Icon';
import { CategoryContext } from '../../Providers/CategoryProvider';

export default function LeadtimeFilter() {
  const { userStore, toggleShowUserStorePanel, showUserStorePanel } = useContext(StoreContext);
  const [pendingStoreChange, togglePendingStoreChange] = useToggle(false);
  const isInitialRender = useInitialRender(true);
  const { categoryChangedToggle } = useContext(CategoryContext);
  const [shouldResetLeadtimeFilter, setShouldResetLeadtimeFilter] = useState(false);

  const {
    updateLeadtimeFilters,
    selectedLeadtimeOption,
    setSelectedLeadtimeOption,
    isSelectedFilter,
    leadtimeFilterOptions,
    filters,
    resetLeadtimeFilters,
  } = useFilters();

  const [isChecked, setIsChecked] = useState(!!isSelectedFilter(selectedLeadtimeOption.property));
  const applyLeadTimeFilterButMissingStore = isChecked && !userStore;

  // Empty deliveryQuery if user inputs something other than the selected leadtime option.
  // works because we intitalize the selected leadtime option on refresh/nav and if no match is found,
  // default leadtime option is set.
  useEffect(() => {
    if (!isEmpty(filters.leadtime) && !isSelectedFilter(selectedLeadtimeOption.property)) {
      updateLeadtimeFilters(selectedLeadtimeOption.property, undefined);
    }
  }, []);

  useEffect(() => {
    if (applyLeadTimeFilterButMissingStore) {
      togglePendingStoreChange();
    }

    if (selectedLeadtimeOption.property === 'default') {
      // If no option is selected, don't set filters
      return;
    } else if (!isChecked) {
      updateLeadtimeFilters('default');
    } else if (isSelectedFilter(selectedLeadtimeOption.property)) {
      updateLeadtimeFilters(selectedLeadtimeOption.property, undefined);
    } else {
      updateLeadtimeFilters(selectedLeadtimeOption.property, selectedLeadtimeOption.value);
    }
  }, [isChecked, shouldResetLeadtimeFilter]);

  useEffect(() => {
    if (applyLeadTimeFilterButMissingStore) {
      toggleShowUserStorePanel();
      resetLeadtimeFilters();
    }
  }, [pendingStoreChange]);

  useEffect(() => {
    if (!shouldResetLeadtimeFilter) {
      setShouldResetLeadtimeFilter(true);
    }
    if (shouldResetLeadtimeFilter) {
      setIsChecked(false);
    }
  }, [categoryChangedToggle]);

  if (leadtimeFilterOptions.length <= 0) {
    return null;
  }

  if (isInitialRender()) {
    return (
      <>
        <Distance size="2" />
        <Skeleton height="24px" />
      </>
    );
  }

  return (
    <>
      <Distance />
      <Box padding="none">
        <Wrapper>
          <LeadTimeSection>
            <ToggleContainer>
              <Toggle
                isActive={isChecked}
                onClick={() => setIsChecked((prev) => !prev)}
                title="Test"
              />
              <TextContainer>
                <Title>Boka och hämta</Title>
                {!isChecked && (
                  <Pitch>
                    <Description>Välj butik och se leveranstid</Description>
                    <TruckIcon className="large symbol" />
                  </Pitch>
                )}
              </TextContainer>
            </ToggleContainer>
          </LeadTimeSection>

          <LeadTimeSection className={isChecked ? undefined : 'hidden'}>
            <Selections>
              <Store>
                <LinkButton onClick={toggleShowUserStorePanel} className="full">
                  <Text whiteSpace="nowrap" overflow="ellipsis" className="flex-grow">
                    {userStore?.storeName ?? 'Välj butik'}
                  </Text>
                  {!showUserStorePanel && (
                    <ChevronDownIcon className="xlarge bump-left" strokeWidth="2" />
                  )}
                  {showUserStorePanel && (
                    <ChevronUpIcon className="xlarge bump-left" strokeWidth="2" />
                  )}
                </LinkButton>
              </Store>

              <DeliveryTime>
                <Text whiteSpace="nowrap">
                  <LeadtimeFilterOptions
                    leadtimeFilterOptions={leadtimeFilterOptions}
                    setSelectedLeadtimeOption={setSelectedLeadtimeOption}
                    selectedLeadtimeOption={selectedLeadtimeOption}
                    updateLeadtimeFilters={updateLeadtimeFilters}
                    pendingStoreChange={pendingStoreChange}
                    togglePendingStoreChange={togglePendingStoreChange}
                    checked={isChecked}
                  />
                </Text>
              </DeliveryTime>
            </Selections>
          </LeadTimeSection>
        </Wrapper>
      </Box>
    </>
  );
}
